import { convertMediaTrack } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerAvailableAudioTracks = (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return {
        availableAudioTracks: {
            tracks: player.availableAudioTracks.map(convertMediaTrack),
        },
    };
};
